import { useEffect } from 'react';

import { getTutorials, setActiveTutorial } from '../store/tutorials';
import { getCurrentUser } from '../services/authService';
import { useAppDispatch, useAppSelector } from '../store/configureStore';

import tutorialService from '../services/tutorialService';

const useTutorial = () => {
	const dispatch = useAppDispatch();
	const tutorials = useAppSelector(getTutorials);

	const user = getCurrentUser();

	useEffect(() => {
		if (user) {
			const lastTutorial = tutorialService.getLastTutorial();
			dispatch(setActiveTutorial(lastTutorial));
		}

		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (tutorials.activeTutorial) {
			tutorialService.storeLastTutorial(tutorials.activeTutorial);
		}
	}, [tutorials.activeTutorial]);
};

export default useTutorial;
